import { CountersignVerificationData } from '../../dtos/countersign-verification-data.dto';
import { DocumentCountersignDTO } from '../../dtos/document-countersign.dto';

export class GetDocumentCountersignInfoAction {
  static readonly type = '[Document] [GET] [Get Document Countersign Info]';

  constructor(
    public organizationId: string,
    public studyId: string,
    public documentId: string,
    public versionNo: number,
  ) {}
}

export class VerifyCountersignPasswordAction {
  static readonly type = '[Document] [POST] [Verify Countersign Password]';

  constructor(
    public organizationId: string,
    public studyId: string,
    public verificationData: CountersignVerificationData,
  ) {}
}

export class CountersignDocumentAction {
  static readonly type = '[Document] [GET] [Countersign Document]';

  public readonly post = {
    notification: {
      success: 'dsmb.document-countersign.success-toastr',
    },
  };

  constructor(
    public organizationId: string,
    public studyId: string,
    public documentId: string,
    public versionNo: number,
    public documentCountersign: DocumentCountersignDTO,
  ) {}
}

export class SendDocumentToCountersignAction {
  static readonly type = '[Document] [POST] [Send Document To Countersign]';

  public readonly post = {
    notification: {
      success: 'dsmb.document-countersign-sent-for-sign.toastr-message',
    },
  };

  constructor(
    public organizationId: string,
    public studyId: string,
    public meetingId: string,
    public discussionItemId: string | null, // Discussion Item can be null
    public decisionId: string | null, // Decision can be null
    public taskId: string | null, // Task can be null
    public userId: string | null, // User can be null
    public documentId: string,
    public versionNo: number,
  ) {}
}
